import React from "react";
import { AnimatePresence, motion } from "framer-motion";

/**
 * A loading transition component that shows skeleton while loading
 * and smoothly transitions to the content when loaded
 *
 * @param {Object} props
 * @param {boolean} props.isLoading - Whether the content is loading
 * @param {React.ReactNode} props.skeleton - The skeleton component to show while loading
 * @param {React.ReactNode} props.children - The actual content to show when loaded
 * @param {Object} props.transition - Animation transition properties
 * @returns {JSX.Element}
 */
function LoadingTransition({
  isLoading,
  skeleton,
  children,
  transition = { duration: 0.4, ease: "easeInOut" },
}) {
  return (
    <div style={{ position: "relative" }} className="h-screen">
      <AnimatePresence mode="wait">
        {isLoading ? (
          <motion.div
            key="loading"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={transition}
            style={{
              position: "absolute",
              width: "100%",
              backgroundColor: "aliceblue",
            }}
          >
            {skeleton}
          </motion.div>
        ) : (
          <motion.div
            key="content"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={transition}
            style={{ position: "absolute", width: "100%" }}
          >
            {children}
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}

export default LoadingTransition;
